import { render, staticRenderFns } from "./ProductCardMini.vue?vue&type=template&id=0794c71d&scoped=true"
import script from "./ProductCardMini.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductCardMini.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProductCardMini.vue?vue&type=style&index=0&id=0794c71d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0794c71d",
  null
  
)

export default component.exports